import { type ReactNode } from 'react';

import { SendBirdChatWrapper } from '~/lib/common/SendbirdChatWrapper';
import { EditNoteDrawerContextProvider } from '~/lib/contexts/EditNoteDrawerContext';
import { MessageDraftsContextProvider } from '~/lib/contexts/MessageDraftsContext';
import { NoteAttachmentModalContextProvider } from '~/lib/contexts/NoteAttachmentModalContext';
import { TaskContextProvider } from '~/lib/contexts/TaskContext';

const MaudProviders = ({ children }: { children: ReactNode }) => (
  <SendBirdChatWrapper>
    <TaskContextProvider>
      <NoteAttachmentModalContextProvider>
        <EditNoteDrawerContextProvider>
          <MessageDraftsContextProvider>
            {children}
          </MessageDraftsContextProvider>
        </EditNoteDrawerContextProvider>
      </NoteAttachmentModalContextProvider>
    </TaskContextProvider>
  </SendBirdChatWrapper>
);

export default MaudProviders;
